import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles({
  description: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 20px',
  },
});

const AttachmentDescription = ({ description = '' }) => {
  const classes = useStyles();

  return (
    <div className={classes.description} dangerouslySetInnerHTML={{ __html: description }}></div>
  );
};

export default AttachmentDescription;
